import React from 'react';
import TextField from 'material-ui/TextField';
import NumberFormat from 'react-number-format';

const ZipStep = ({ fields, assignRef, onInputKeyDown }) => (
  <div className="step-content">
    <h2>Póstnúmer</h2>
    <p>
      Google Maps er ekki alveg með íslensk póstnúmer á hreinu...<br />
      Værirðu nokkuð til í að slá það inn fyrir okkur?
    </p>
    <div className="input-wrapper columns zip-input">
      <TextField
        value={fields.zip.value}
        ref={assignRef ? c => assignRef('zip', c) : null}
        onKeyDown={onInputKeyDown}
        type="number" pattern="[0-9]*"
        min="100" max="999"
        hintText="Sláðu inn póstnúmer"
        fullWidth
      >
        <NumberFormat {...fields.zip} format="###" />
      </TextField>
      <span className="word-count">{fields.zip.value.length} / 3</span>
    </div>
  </div>
);

ZipStep.propTypes = {
  fields: React.PropTypes.object.isRequired,
  assignRef: React.PropTypes.func,
  onInputKeyDown: React.PropTypes.func,
};

export default ZipStep;



// WEBPACK FOOTER //
// ./src/browser/steps/ZipStep/ZipStep.js